var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9382 7.66933C18.512 4.24469 15.1704 2.01004 11.4607 2.00013C7.46246 1.97907 3.90737 4.54006 2.66105 8.3391C1.41473 12.1381 2.7619 16.3074 5.99559 18.6588C9.22927 21.0103 13.6107 21.0068 16.8407 18.6501L19.7207 21.5301C20.0135 21.8226 20.4878 21.8226 20.7807 21.5301C21.0731 21.2373 21.0731 20.7629 20.7807 20.4701L17.9907 17.6801C20.5968 15.04 21.3644 11.094 19.9382 7.66933ZM18.6011 14.1691C17.4036 17.0547 14.5849 18.9342 11.4607 18.9301V18.8901C7.22037 18.8847 3.77812 15.4603 3.75066 11.2201C3.74662 8.09586 5.62605 5.27717 8.51172 4.0797C11.3974 2.88223 14.7203 3.54208 16.9295 5.75127C19.1387 7.96046 19.7986 11.2834 18.6011 14.1691Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/Magnifier.cf088bf8b2db7f00d8a7ab3fafa2a8a0.svg";
export { ForwardRef as ReactComponent };